// import React from 'react';
// import { IoMdClose } from 'react-icons/io';
// import './AddUserModal.css';

// const AddUserModal = ({ closeModal }) => {
//   return (
//     <div>
//       {/* Overlay */}
//       <div className="modal-overlay" onClick={closeModal}></div>

//       {/* Modal */}
//       <div className="add-user-modal">
//         <div className="modal-header">
//           <h5>Add New User</h5>
//           <button className="close-btn" onClick={closeModal}>
//             <IoMdClose />
//           </button>
//         </div>

//         <p className="modal-subtitle">
//           Add a new RO, BM or BCM to a branch. Click save when you&apos;re done.
//         </p>

//         <div className="add-user-modal-content">
//           <div className="form-group-row">
//             <div>
//               <label>First Name</label>
//               <input type="text" placeholder="First Name" />
//             </div>
//             <div>
//               <label>Last Name</label>
//               <input type="text" placeholder="Last Name" />
//             </div>
//           </div>
//           <div className="form-group-row">
//             <div>
//               <label>Employee ID</label>
//               <input type="text" placeholder="1001" />
//             </div>
//           </div>
//           <div className="form-group-row">
//             <div>
//               <label>Email</label>
//               <input type="text" placeholder="email@seedsfincap.in" />
//             </div>
//           </div>
//           <div className="form-group-row">
//             <div>
//               <label>Password</label>
//               <input type="text" placeholder="Enter password" />
//             </div>
//           </div>

//           <div className="form-group-row">
//             <div>
//               <label>Role</label>
//               <select>
//                 <option>Select Role</option>
//               </select>
//             </div>
//           </div>
//           <div className="form-group-row">
//             <div>
//               <label>Branch</label>
//               <select>
//                 <option>Select Branch</option>
//               </select>
//             </div>
//           </div>

//           <div className="modal-actions">
//             <button className="add-user-btn">Save User</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AddUserModal;

import React, { useState, useEffect, useRef, useMemo } from 'react';
import { IoMdClose } from 'react-icons/io';
import { IoSearch } from 'react-icons/io5';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import axios from 'axios';
import './AddUserModal.css';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getAllRoles } from '../../../redux/UserReducer/action';

// ADD API_BASE_URL HERE
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const AddUserModal = ({ closeModal, onUserAdded, selectedBranch, preSelectedRole, onSuccess }) => {
  const { rolesList } = useSelector((store) => {
      return {
          rolesList: store.UserReducer.roles.rolesList
      }
  })

  const initialBranchCode = typeof selectedBranch === 'string'
    ? selectedBranch
    : selectedBranch?.branch_code || '';

  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    emp_id: '',
    email: '',
    password: '',
    confirm_password: '',
    // role_code: preSelectedRole || '',
    role_name: '',
    branch_code: selectedBranch?.branch_code || '',
    role_id: '',
    manager_id: '',
  });

  const [branches, setBranches] = useState([]);
  const [filteredBranches, setFilteredBranches] = useState([]);
  const [branchSearch, setBranchSearch] = useState('');
  const [showBranchDropdown, setShowBranchDropdown] = useState(false);
  const [selectedBranchDisplay, setSelectedBranchDisplay] = useState('');
  const [loading, setLoading] = useState(false);
  const [globalError, setGlobalError] = useState(null);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [allRolesLimit, setAllRolesLimit] = useState(parseInt(sessionStorage.getItem('allRolesLimit')) || 2000);

  // Password visibility state
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [roleFilters, setRoleFilters] = useState({
      is_active: true
  });

  const dispatch = useDispatch();

  // autocomplete
  const [firstNameSuggestions, setFirstNameSuggestions] = useState([]);
  const [lastNameSuggestions, setLastNameSuggestions] = useState([]);
  const [emailSuggestions, setEmailSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState({
    first_name: false,
    last_name: false,
    email: false,
  });

  // validation
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const searchInputRef = useRef(null);
  const dropdownRef = useRef(null);
  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const emailRef = useRef(null);
  const empIdRef = useRef(null);

  const branchRoles = ['RO', 'BM', 'BCM'];
  // const isBranchRole = branchRoles.includes(formData.role_code?.toUpperCase());
  const isBranchRole = selectedBranch?.branch_code !== "HO" && selectedBranch !== "HO" ? true : false;


  const getToken = () => {
    try {
      const tokensString = sessionStorage.getItem('tokens');
      if (!tokensString) return '';
      const tokensObject = JSON.parse(tokensString);
      return tokensObject.token || '';
    } catch {
      return '';
    }
  };

  const getUserHistory = () => {
    try {
      const historyString = sessionStorage.getItem('userFormHistory');
      return historyString ? JSON.parse(historyString) : [];
    } catch {
      return [];
    }
  };

  const saveToHistory = (userData) => {
    try {
      const history = getUserHistory();
      const newEntry = {
        first_name: userData.first_name,
        last_name: userData.last_name,
        emp_id: userData.emp_id,
        email: userData.email,
        // role_code: userData.role_code,
        role_name: userData.role_name,
        timestamp: new Date().toISOString(),
      };

      const updatedHistory = [newEntry, ...history].slice(0, 50);
      sessionStorage.setItem('userFormHistory', JSON.stringify(updatedHistory));
    } catch {}
  };

  // history suggestions
  useEffect(() => {
    const history = getUserHistory();

    setFirstNameSuggestions([
      ...new Set(history.map((h) => h.first_name).filter(Boolean)),
    ]);

    setLastNameSuggestions([
      ...new Set(history.map((h) => h.last_name).filter(Boolean)),
    ]);

    setEmailSuggestions([
      ...new Set(history.map((h) => h.email).filter(Boolean)),
    ]);
  }, []);

  useEffect(() => {
    if (formData.first_name && formData.last_name && !formData.email) {
      const emailSuggestion = `${formData.first_name.toLowerCase()}.${formData.last_name.toLowerCase()}@seedsfincap.in`;
      if (!emailSuggestions.includes(emailSuggestion)) {
        setEmailSuggestions((prev) => [emailSuggestion, ...prev]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.first_name, formData.last_name]);

  // fetch branches - UPDATED TO USE API_BASE_URL
  useEffect(() => {
    const fetchBranches = async () => {
      const token = getToken();
      if (!token) {
        setGlobalError('No authentication token found.');
        return;
      }

      setLoading(true);
      try {
        const res = await axios.get(
          `${API_BASE_URL}/officer/get-branch-report?page=1&limit=2000&is_download=false`,
          {
            headers: {
              accept: '*/*',
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.data.status && res.data.data.branch_data) {
          setBranches(res.data.data.branch_data);
        }
      } catch (err) {
        setGlobalError('Failed to load branches');
      } finally {
        setLoading(false);
      }
    };

    fetchBranches();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        searchInputRef.current &&
        !searchInputRef.current.contains(event.target)
      ) {
        setShowBranchDropdown(false);
      }

      if (
        firstNameRef.current &&
        !firstNameRef.current.contains(event.target)
      ) {
        setShowSuggestions((prev) => ({ ...prev, first_name: false }));
      }
      if (lastNameRef.current && !lastNameRef.current.contains(event.target)) {
        setShowSuggestions((prev) => ({ ...prev, last_name: false }));
      }
      if (emailRef.current && !emailRef.current.contains(event.target)) {
        setShowSuggestions((prev) => ({ ...prev, email: false }));
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (branchSearch.trim() === '') {
      setFilteredBranches([]);
      setShowBranchDropdown(false);
    } else {
      const q = branchSearch.toLowerCase();
      setFilteredBranches(
        branches.filter(
          (b) =>
            b.branch_code.toLowerCase().includes(q) ||
            b.branch_name.toLowerCase().includes(q)
        )
      );
      setShowBranchDropdown(true);
    }
  }, [branchSearch, branches]);

  useEffect(() => {
    dispatch(getAllRoles(1, 2000, roleFilters));
  }, [dispatch]);

  useEffect(() => {
    const bCode = typeof selectedBranch === 'string'
      ? selectedBranch
      : selectedBranch?.branch_code || '';

    if (bCode) {
      setFormData((prev) => ({
        ...prev,
        branch_code: bCode,
      }));

      const found = branches?.find(
        (b) => b.branch_code?.toLowerCase() === bCode.toLowerCase()
      );

      if (found) {
        const displayStr = `${found.branch_name}: ${found.branch_code}`;
        setSelectedBranchDisplay(displayStr);
        setBranchSearch(displayStr);
      } else {
        setSelectedBranchDisplay(bCode);
        setBranchSearch(bCode);
      }
    }
  // }, [formData.role_code, selectedBranch?.branch_code, isBranchRole]);
  }, [formData.role_name, selectedBranch?.branch_code, isBranchRole]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // if (name === 'role_code') {
    if (name === 'role_name') {
      // const selectedRole = rolesList?.find(
      //   (r) => r.short_name === value
      // );
      const selectedRole = rolesList?.find(
        (r) => r.role_name === value
      );

      setFormData((prev) => ({
        ...prev,
        // role_code: value,
        role_name: value,
        role_id: selectedRole?.role_id || '',
      }));

      return;
    }

    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setErrors((prev) => ({ ...prev, [e.target.name]: undefined }));
    setGlobalError(null);
  };

  const handleSuggestionSelect = (field, value) => {
    const updatedData = { ...formData, [field]: value };
    setFormData(updatedData);
    const allErrors = validate(updatedData);
    setErrors((prev) => ({ ...prev, [field]: allErrors[field] }));
    setShowSuggestions((prev) => ({ ...prev, [field]: false }));
  };

  const handleBranchSearchChange = (e) => {
    setBranchSearch(e.target.value);
    setFormData((prev) => ({ ...prev, branch_code: '' }));
    setSelectedBranchDisplay('');
    setErrors((prev) => ({ ...prev, branch_code: undefined }));
  };

  const handleBranchSearchFocus = () => {
    if (branchSearch.trim()) setShowBranchDropdown(true);
  };

  const handleBranchSelect = (branch) => {
    setFormData((prev) => ({ ...prev, branch_code: branch.branch_code }));
    setSelectedBranchDisplay(`${branch.branch_name}: ${branch.branch_code}`);
    setBranchSearch(`${branch.branch_name}: ${branch.branch_code}`);
    setErrors((prev) => ({ ...prev, branch_code: undefined }));
    setShowBranchDropdown(false);
  };

  const validate = (v) => {
    const e = {};
    if (!v.first_name.trim()) e.first_name = 'First name is required';
    if (!v.last_name.trim()) e.last_name = 'Last name is required';
    if (!v.emp_id.trim()) e.emp_id = 'Employee ID is required';
    if (!v.email.trim()) e.email = 'Email is required';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.email))
      e.email = 'Enter valid email';
    if (!v.password) e.password = 'Password is required';
    if (!v.confirm_password) e.confirm_password = 'Please confirm password';
    else if (v.confirm_password !== v.password)
      e.confirm_password = 'Passwords do not match';
    // if (!v.role_code) e.role_code = 'Role is required';
    if (!v.role_name) e.role_name = 'Role Name is required';

    // if (isBranchRole && formData.role_code?.toUpperCase() !== 'BCM' && !v.branch_code) {
    //   e.branch_code = 'Branch is required';
    // }
    if (isBranchRole && !v.branch_code) {
      e.branch_code = 'Branch is required';
    }

    return e;
  };

  const handleBlur = (field) => () => {
    setTouched((prev) => ({ ...prev, [field]: true }));
    const allErrors = validate(formData);
    setErrors((prev) => ({ ...prev, [field]: allErrors[field] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);

    const allErrors = validate(formData);
    setErrors(allErrors);
    setTouched({
      first_name: true,
      last_name: true,
      emp_id: true,
      email: true,
      password: true,
      confirm_password: true,
      // role_code: true,
      role_name: true,
      branch_code: true,
    });

    if (Object.keys(allErrors).length > 0) {
      setSubmitLoading(false);
      return;
    }

    const token = getToken();
    if (!token) {
      setGlobalError('No token found');
      setSubmitLoading(false);
      return;
    }

    const branchRoles = ['RO', 'BM', 'BCM'];
    // const isBranchRole = branchRoles.includes(formData.role_code);
    // const isBranchRole = selectedBranch?.branch_code !== "HO" ? true : false;

    try {
      let url = '';
      let payload = {};

      if (isBranchRole) {
        // OFFICER API
        url = `${API_BASE_URL}/officer/register`;

        payload = {
          first_name: formData.first_name,
          last_name: formData.last_name,
          email: formData.email,
          password: formData.password,
          // role_code: formData.role_code,
          role_id: Number(formData.role_id),
          branch_code: formData.branch_code,
          emp_id: formData.emp_id,
        };
      } else {
        // safety check
        if (!formData.role_id) {
          toast.error('Invalid role mapping');
          return;
        }

        // HO OFFICER API
        url = `${API_BASE_URL}/officer/create-ho-officer`;

        payload = {
          first_name: formData.first_name,
          last_name: formData.last_name,
          email: formData.email,
          password: formData.password,
          emp_id: formData.emp_id,
          role_id: Number(formData.role_id),
          manager_id: null, // ALWAYS NULL
        };
      }

      console.log({ url, payload });


      // UPDATED TO USE API_BASE_URL
      // const res = await axios.post(
      //   `${API_BASE_URL}/officer/register`,
      //   {
      //     first_name: formData.first_name,
      //     last_name: formData.last_name,
      //     email: formData.email,
      //     password: formData.password,
      //     role_code: formData.role_code,
      //     branch_code: formData.branch_code,
      //     emp_id: formData.emp_id,
      //   },
      //   {
      //     headers: {
      //       accept: '*/*',
      //       Authorization: `Bearer ${token}`,
      //       'Content-Type': 'application/json',
      //     },
      //   }
      // );

      const res = await axios.post(url, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
      });

      if (res.data.status) {
        saveToHistory(formData);
        onUserAdded && onUserAdded(res.data);
        onSuccess?.();   // calls only if defined
        closeModal();
        toast.success(`Officer registered successfully`);
      } else {
        setGlobalError(res.data.message);
        toast.error(`Failed to add user.`);
      }
    } catch (err) {
      setGlobalError(err.response?.data?.message || 'Failed to add user');
      toast.error(`${err.response?.data?.message}`);
    } finally {
      setSubmitLoading(false);
    }
  };

  // const roleOptions = [
  //   { label: 'BM', value: 'BM' },
  //   { label: 'BCM', value: 'BCM' },
  //   { label: 'RO', value: 'RO' },
  // ];

  const norm = (s) => s?.toString().trim().toUpperCase();

  // department_id that the pre-selected role short code (RO/BM/BCM/type) belongs to.
  // preSelectedRole / branchRoles are role short codes, not department names, so we
  // resolve them to department_id via rolesList and filter on that instead.
  const preSelectedDeptId = preSelectedRole
    ? (rolesList?.find(role => norm(role?.short_name) === norm(preSelectedRole))?.department_id ?? null)
    : null;

  // distinct department_ids that the branch roles (RO/BM/BCM) belong to
  const branchDeptIds = [
    ...new Set(
      (rolesList ?? [])
        .filter(role => branchRoles.includes(norm(role?.short_name)))
        .map(role => role?.department_id)
        .filter(id => id != null)
    ),
  ];

  const matchesPreSelectedDept = (role) =>
    preSelectedDeptId != null
      ? role?.department_id === preSelectedDeptId
      : norm(role?.short_name) === norm(preSelectedRole);

  const isBranchDeptRole = (role) =>
    branchDeptIds.length
      ? branchDeptIds.includes(role?.department_id)
      : branchRoles.includes(norm(role?.short_name));

  const roleOptions =
    // branch not selected and role already selected (all officers screen)
  (preSelectedRole && !selectedBranch) ? [
    ...new Map(
      rolesList
        ?.filter(matchesPreSelectedDept)
        ?.map(role => [role.role_name, role.role_name])
    ).values()
  ]?.map(roleName => ({
    label: roleName,
    value: roleName,
  })) :
  // branch is selected and role already selected (Add RO)
  (preSelectedRole && selectedBranch?.branch_code !== 'HO') ? [
    ...new Map(
      rolesList
        ?.filter(matchesPreSelectedDept)
        ?.map(role => [role.role_name, role.role_name])
    ).values()
  ]?.map(roleName => ({
    label: roleName,
    value: roleName,
  })) :
  //otherwise, role not already selected (main page add user HO branch)
  (!preSelectedRole && selectedBranch === 'HO') ?
  [
    ...new Map(
      rolesList
        ?.filter(role => !isBranchDeptRole(role))
        ?.map(role => [role.role_name, role.role_name])
    ).values()
  ]?.map(roleName => ({
    label: roleName,
    value: roleName,
  })) :
  // branch not selected and role not already selected
  (!preSelectedRole && selectedBranch?.branch_code !== 'HO') ?
  [
    ...new Map(
      rolesList
        ?.filter(role => isBranchDeptRole(role))
        ?.map(role => [role.role_name, role.role_name])
    ).values()
  ]?.map(roleName => ({
    label: roleName,
    value: roleName,
  })) :
  //otherwise, display all roles
  [
    ...new Map(
      rolesList
        ?.map(role => [role.role_name, role.role_name])
    ).values()
  ]?.map(roleName => ({
    label: roleName,
    value: roleName,
  }));

  const roleIdOptions = rolesList?.map(role => ({
    // label: role.name || role.short_name,
    // value: role.role_id,
    label: role.role_name,
    value: role.role_id,
  }));

  console.log({ rolesList, roleOptions, roleIdOptions, selectedBranch, preSelectedRole, isBranchRole });

  return (
    <div>
      <div className="modal-overlay" onClick={closeModal}></div>

      <div className="add-user-modal">
        <div className="modal-header">
          <h5>Add New User</h5>
          <button className="close-btn" onClick={closeModal}>
            <IoMdClose />
          </button>
        </div>

        <p className="modal-subtitle">
          {/* Add a new RO, BM or BCM to a branch. Click save when done. */}
          Add a new user
        </p>

        {globalError && <div className="error-message">{globalError}</div>}

        <form className="add-user-modal-content" onSubmit={handleSubmit}>
          {/* FIRST NAME */}
          <div className="form-group-row">
            <div ref={firstNameRef} className="autocomplete-wrapper">
              <label>First Name</label>
              <input
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                onBlur={handleBlur('first_name')}
                onFocus={() =>
                  setShowSuggestions((p) => ({ ...p, first_name: true }))
                }
              />
              {touched.first_name && errors.first_name && (
                <div className="error-text">{errors.first_name}</div>
              )}

              {showSuggestions.first_name &&
                firstNameSuggestions.length > 0 && (
                  <div className="suggestion-dropdown">
                    {firstNameSuggestions
                      .filter((s) =>
                        s
                          .toLowerCase()
                          .includes(formData.first_name.toLowerCase())
                      )
                      .slice(0, 5)
                      .map((s, i) => (
                        <div
                          key={i}
                          className="suggestion-item"
                          onClick={() =>
                            handleSuggestionSelect('first_name', s)
                          }
                        >
                          {s}
                        </div>
                      ))}
                  </div>
                )}
            </div>
          </div>

          {/* LAST NAME */}
          <div className="form-group-row">
            <div ref={lastNameRef} className="autocomplete-wrapper">
              <label>Last Name</label>
              <input
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                onBlur={handleBlur('last_name')}
                onFocus={() =>
                  setShowSuggestions((p) => ({ ...p, last_name: true }))
                }
              />
              {touched.last_name && errors.last_name && (
                <div className="error-text">{errors.last_name}</div>
              )}

              {showSuggestions.last_name && lastNameSuggestions.length > 0 && (
                <div className="suggestion-dropdown">
                  {lastNameSuggestions
                    .filter((s) =>
                      s.toLowerCase().includes(formData.last_name.toLowerCase())
                    )
                    .slice(0, 5)
                    .map((s, i) => (
                      <div
                        key={i}
                        className="suggestion-item"
                        onClick={() => handleSuggestionSelect('last_name', s)}
                      >
                        {s}
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>

          {/* EMP ID */}
          <div className="form-group-row">
            <div ref={empIdRef} className="autocomplete-wrapper">
              <label>Employee ID</label>
              <input
                name="emp_id"
                value={formData.emp_id}
                onChange={handleChange}
                onBlur={handleBlur('emp_id')}
              />
              {touched.emp_id && errors.emp_id && (
                <div className="error-text">{errors.emp_id}</div>
              )}
            </div>
          </div>

          {/* EMAIL */}
          <div className="form-group-row">
            <div ref={emailRef} className="autocomplete-wrapper">
              <label>Email</label>
              <input
                name="email"
                value={formData.email}
                onChange={handleChange}
                onBlur={handleBlur('email')}
                onFocus={() =>
                  setShowSuggestions((p) => ({ ...p, email: true }))
                }
              />
              {touched.email && errors.email && (
                <div className="error-text">{errors.email}</div>
              )}

              {showSuggestions.email && emailSuggestions.length > 0 && (
                <div className="suggestion-dropdown">
                  {emailSuggestions
                    .filter((s) =>
                      s.toLowerCase().includes(formData.email.toLowerCase())
                    )
                    .slice(0, 5)
                    .map((s, i) => (
                      <div
                        key={i}
                        className="suggestion-item"
                        onClick={() => handleSuggestionSelect('email', s)}
                      >
                        {s}
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>

          {/* PASSWORD */}
          <div className="form-group-row">
            <div className="password-wrapper">
              <label>Password</label>
              <div className="password-input-container">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  onBlur={handleBlur('password')}
                  className="password-input"
                />

                <span
                  className="eye-icon"
                  onClick={() => setShowPassword((v) => !v)}
                  role="button"
                  tabIndex={0}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                </span>
              </div>

              {touched.password && errors.password && (
                <div className="error-text">{errors.password}</div>
              )}
            </div>
          </div>

          {/* CONFIRM PASSWORD */}
          <div className="form-group-row">
            <div className="password-wrapper">
              <label>Re-enter / Confirm Password</label>
              <div className="password-input-container">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  name="confirm_password"
                  value={formData.confirm_password}
                  onChange={handleChange}
                  onBlur={handleBlur('confirm_password')}
                  className="password-input"
                />

                <span
                  className="eye-icon"
                  onClick={() => setShowConfirmPassword((v) => !v)}
                  role="button"
                  tabIndex={0}
                  aria-label={
                    showConfirmPassword ? 'Hide password' : 'Show password'
                  }
                >
                  {showConfirmPassword ? (
                    <AiOutlineEyeInvisible />
                  ) : (
                    <AiOutlineEye />
                  )}
                </span>
              </div>

              {touched.confirm_password && errors.confirm_password && (
                <div className="error-text">{errors.confirm_password}</div>
              )}
            </div>
          </div>

          {/* ROLE */}
          {/* <div className="form-group-row">
            <div>
              <label>Role</label>
              <select
                name="role_code"
                value={formData.role_code}
                onChange={handleChange}
                onBlur={handleBlur('role_code')}
                disabled={preSelectedRole}
              >
                <option value="">Select Role</option>
                {roleOptions?.map((role) => (
                  <option key={role.value} value={role.value}>
                    {role.label}
                  </option>
                ))}
              </select>
              {touched.role_code && errors.role_code && (
                <div className="error-text">{errors.role_code}</div>
              )}
            </div>
          </div> */}

          {/* ROLE NAME */}
          <div className="form-group-row">
            <div>
              <label>Role Name</label>
              <select
                name="role_name"
                value={formData.role_name}
                onChange={handleChange}
                onBlur={handleBlur('role_name')}
              >
                <option value="">Select Role</option>
                {roleOptions?.map((role) => (
                  <option key={role.value} value={role.value}>
                    {role.label}
                  </option>
                ))}
              </select>
              {touched.role_name && errors.role_name && (
                <div className="error-text">{errors.role_name}</div>
              )}
            </div>
          </div>

          {/* BRANCH SEARCH */}
          {isBranchRole && <div className="form-group-row">
            <div className="branch-search-container">
              <label>Branch</label>

              <div className="search-input-wrapper" ref={dropdownRef}>
                <input
                  ref={searchInputRef}
                  type="text"
                  placeholder={
                    loading
                      ? 'Loading branches...'
                      : 'Type to search branch by name or code...'
                  }
                  value={branchSearch || selectedBranch?.branch_code}
                  onChange={handleBranchSearchChange}
                  onFocus={handleBranchSearchFocus}
                  disabled={loading || !!(selectedBranch && selectedBranch.branch_code)}
                  // disabled={loading}
                  className="branch-search-input"
                  autoComplete="off"
                />

                <span className="search-icon-right" aria-hidden="true">
                  <IoSearch />
                </span>

                {showBranchDropdown &&
                  branchSearch.trim() !== '' &&
                  !loading && (
                    <div className="branch-dropdown-results">
                      {filteredBranches.length > 0 &&
                        filteredBranches.map((branch) => (
                          <div
                            key={branch.branch_code}
                            className={`branch-dropdown-item ${
                              formData.branch_code === branch.branch_code
                                ? 'selected'
                                : ''
                            }`}
                            onClick={() => handleBranchSelect(branch)}
                          >
                            <div className="branch-item-name">
                              <strong>{branch.branch_name}</strong>
                            </div>
                            <div className="branch-item-code">
                              Branch Code: {branch.branch_code}
                            </div>
                          </div>
                        ))}
                    </div>
                  )}
              </div>

              {touched.branch_code && errors.branch_code && (
                <div className="error-text">{errors.branch_code}</div>
              )}

              {selectedBranchDisplay && (
                <small className="selected-branch-info">
                  ✓ Selected: {selectedBranchDisplay}
                </small>
              )}
            </div>
          </div>}

          <div className="modal-actions">
            <button
              type="submit"
              className="add-user-btn"
              disabled={submitLoading || loading}
            >
              {submitLoading ? 'Saving...' : 'Save User'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUserModal;
